import React, {FC, useState} from 'react'
import AlertMessage from '../../../common/alert/AlertMsg'
import SharedData from '../../../common/SharedData'
import {enqueueBulkSpecial} from '../core/_requests'
import Loader from '../../../common/Loader'
import {useNavigate} from 'react-router-dom'
import { useIntl } from 'react-intl'
type IProps = {
  bulkFile: any
  setBulkFile: React.Dispatch<any>
  setStartDate: React.Dispatch<any>
  setEndDate: React.Dispatch<any>
  startDate: any
  endDate: any
}
const SubmitButtonRow: FC<IProps> = ({
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  bulkFile,
  setBulkFile,
}) => {
  const {formatMessage} = useIntl();
  const {currentUser, language} = SharedData()
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  const isFormHasError = () => {
    let hasError = false
    setBulkFile({
      ...bulkFile,
      error: false,
    })
    setStartDate({
      ...startDate,
      error: false,
      msg: ''
    })
    setEndDate({
      ...endDate,
      error: false,
      msg: ''
    })
    if (!bulkFile.value) {
      setBulkFile({
        ...bulkFile,
        error: true,
      })
      hasError = true
    }
    if (!startDate.value) {
      setStartDate({
        ...startDate,
        error: true,
      })
      hasError = true
    }
    if (!endDate.value) {
      setEndDate({
        ...endDate,
        error: true,
      })
      hasError = true
    }
    return hasError
  }
  const handleSubmit = async () => {
    if (!isFormHasError()) {
      setIsLoading(true)
      try {
        // Async: the discount sheet is queued and processed in the background —
        // the supplier tracks progress + downloads the result on the Bulk Jobs
        // page, instead of waiting in-request for the result blob.
        const res: any = await enqueueBulkSpecial(
          currentUser?.token,
          {
            file: bulkFile.value,
            date_start: startDate.value,
            date_end: endDate.value,
          },
          language
        )
        if (res?.data?.job_id) {
          navigate('/products/bulk-jobs')
        } else {
          setError(true)
        }
      } catch (exp: any) {
        const error = exp?.response?.data?.error
        if (error) {
          if (error.date_start) {
            setStartDate({
              ...startDate,
              error: true,
              msg: Array.isArray(error.date_start) ? error.date_start[0] : error.date_start,
            })
          }
          if (error.date_end) {
            setEndDate({
              ...endDate,
              error: true,
              msg: Array.isArray(error.date_end) ? error.date_end[0] : error.date_end,
            })
          }
        }
        setError(true)
      }
      setIsLoading(false)
    } else {
    }
  }

  return (
    <>
      <div className='adb-actionbar'>
        <div className='adb-actionbar-note'>
          <i className='fas fa-shield-halved' aria-hidden='true' />
          <span>{formatMessage({ id: "by_uploading_products_stnrd" })}</span>
        </div>
        <button onClick={handleSubmit} className='adb-actionbar-btn'>
          {formatMessage({ id: "upload_and_process" })}
        </button>
      </div>
      {isLoading && <Loader isFull={true} />}
      {error === true && (
        <AlertMessage
          title={formatMessage({ id: "something_wrong_title" })}
          message={formatMessage({ id: "something_wrong_desc" })}
          onClose={() => setError(false)}
        />
      )}
    </>
  )
}

export default SubmitButtonRow
